import { render, staticRenderFns } from "./ManageMenu.html?vue&type=template&id=4ef2c30c&scoped=true&"
import script from "./ManageMenu.vue?vue&type=script&lang=js&"
export * from "./ManageMenu.vue?vue&type=script&lang=js&"
import style0 from "./ManageMenu.scss?vue&type=style&index=0&id=4ef2c30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2c30c",
  null
  
)

export default component.exports